import React from "react";

const About = () => {
  return (
    <React.Fragment>
      <div>This is About</div>
    </React.Fragment>
  );
};

export default About;
